"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCampaignCountryId = exports.makeGetCampaignById = exports.getCampaignsMap = exports.getCampaigns = exports.getIsCampaignsFulfilled = exports.getIsCampaignsPending = exports.getCampaignsState = void 0;

var _ramda = require("ramda");

var _reselect = require("reselect");

var _utils = require("@alycecom/utils");

var _campaigns = require("./campaigns.reducer");

var getCampaignsState = function getCampaignsState(state) {
  return state.createGift.campaigns;
};

exports.getCampaignsState = getCampaignsState;

var selectors = _campaigns.campaignsAdapter.getSelectors(getCampaignsState);

var getIsCampaignsPending = (0, _ramda.pipe)(getCampaignsState, function (state) {
  return state.status === _utils.StateStatus.Pending;
});
exports.getIsCampaignsPending = getIsCampaignsPending;
var getIsCampaignsFulfilled = (0, _ramda.pipe)(getCampaignsState, function (state) {
  return state.status === _utils.StateStatus.Fulfilled;
});
exports.getIsCampaignsFulfilled = getIsCampaignsFulfilled;
var getCampaigns = selectors.getAll;
exports.getCampaigns = getCampaigns;
var getCampaignsMap = selectors.getEntities;
exports.getCampaignsMap = getCampaignsMap;

var makeGetCampaignById = function makeGetCampaignById(campaignId) {
  return (0, _reselect.createSelector)(getCampaignsMap, function (campaigns) {
    return campaignId ? campaigns[campaignId] : null;
  });
};

exports.makeGetCampaignById = makeGetCampaignById;
var getCampaignCountryId = (0, _ramda.pipe)(getCampaignsState, function (state) {
  return state.countryId;
});
exports.getCampaignCountryId = getCampaignCountryId;